import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment } from 'react';
import { TableFooterCell } from './TableFooterCell';
export const TableFooter = ({ table }) => {
    const footerGroups = table.getFooterGroups();
    const needsFooter = footerGroups
        .flatMap(({ headers }) => headers.map((header) => header.column.columnDef.footer))
        .some(Boolean);
    return needsFooter ? (_jsx(_Fragment, { children: footerGroups.map((footerGroup) => (_jsx(Fragment, { children: footerGroup.headers.map((header) => (_jsx(TableFooterCell, { header: header }, header.id))) }, footerGroup.id))) })) : null;
};
//# sourceMappingURL=TableFooter.js.map